import React from 'react';
import fofImage from '../../assets/img/fourOhFour.png';
import Button from '../../components/CustomButtons/Button.js';
import { Link } from 'react-router-dom';
import './FourOFour.css';

export default function FourOFour() {
  return (
    <div className='fof-div'>
      <img
        src={fofImage}
        alt='404 - the page you were looking for is not found'
      />
      <h2>Page does not exist or you are not authorized to access it</h2>
      <Link to='/' style={{ textDecoration: 'none' }}>
        <Button color='info' round>
          Go Back
        </Button>
      </Link>
    </div>
  );
}
